module.exports = __webpack_public_path__ + "img/w3_check_circle_white.be192f54.png";